import { render, staticRenderFns } from "./AlarmBreadcrumbController.vue?vue&type=template&id=943b45ce&scoped=true&"
import script from "./AlarmBreadcrumbController.vue?vue&type=script&lang=js&"
export * from "./AlarmBreadcrumbController.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "943b45ce",
  null
  
)

export default component.exports